import Header from "./Header";
import Footer from "./Footer";
import {Chart, registerables} from "chart.js";
import {ReactSession} from "react-client-session";
import {AES, enc} from "crypto-js";
import {Suspense, useEffect, useState} from "react";
import annotationPlugin from 'chartjs-plugin-annotation';
import TableHeaders from "./component-assets/TableHeaders";
import {
    checkAll, complexDelimDisplay, formCheck,
    formSuccess,
    formatDateToMMDD,
    handleSubmitActions,
    isBannerPresent,
    paginateData, showModal,
    sortFunc, headerFilterFunc, searchFunc
} from "../libs";
import ApiRequester from "./ApiRequester";
import Button from "./component-assets/Button";
import TableBody from "./component-assets/TableBody";
import {ToastContainer} from "react-toastify";
import Navigation from "./Navigation";
import {CSVLink} from "react-csv";
import TableSkeleton from "./component-assets/skeletons/TableSkeleton";
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import HourlyLineAndBarChart from "./charts/HourlyLineAndBarChart";
import LineTrendingChart from "./charts/LineTrendingChart";

const CorpDashV2 = () => {

    Chart.register(...registerables);
    Chart.register(annotationPlugin);

    let dData, headerData, csvHeaders, areaTypeHeaders, deviceCatHeaders, trendsHeaderData, csvTrendsHeaders;

    headerData = [
        {label: "Campus Name", key: "campus_name", align: "left", filtered: true, sorts: true, rowSpan: true, row: 1, rows: 2},
        {label: "Total Events", key: "total_events", align: "center", filtered: false, sorts: true, rowSpan: true, row: 1, rows: 2},
        {label: "Avg Daily Events", key: "avg_daily_events", align: "center", filtered: false, sorts: true, rowSpan: true, row: 1, rows: 2},
        {label: "Avg Response Rate", key: "avg_response_time", align: "center", filtered: false, sorts: true, rowSpan: true, row: 1, rows: 2},
        {label: "Residents", key: "resident_count", align: "center", filtered: false, sorts: true, rowSpan: true, row: 1, rows: 2},
        {label: "# Events", key: "total_events_1st", align: "center", filtered: false, sorts: true, rowSpan: true, row: 1, rows: 2, bgColor: "#27B4FFFF"},
        {label: "Avg Daily", key: "avg_daily_events_1st", align: "center", filtered: false, sorts: true, rowSpan: true, row: 1, rows: 2, bgColor: "#27B4FFFF"},
        {label: "Response Rates (Minutes)", key: "", align: "center", filtered: false, sorts: false, row: 1, colSpan: true, cols: 2, bgColor: "#27B4FFFF"},
        {label: "Avg", key: "avg_response_time_1st", align: "center", filtered: false, sorts: true, row: 2, bgColor: "#27B4FFFF"},
        {label: "Max", key: "max_response_time_1st", align: "center", filtered: false, sorts: true, row: 2, bgColor: "#27B4FFFF"},
        {label: "# Events", key: "total_events_2nd", align: "center", filtered: false, sorts: true, rowSpan: true, row: 1, rows: 2, bgColor: "#276BFFFF"},
        {label: "Avg Daily", key: "avg_daily_events_2nd", align: "center", filtered: false, sorts: true, rowSpan: true, row: 1, rows: 2, bgColor: "#276BFFFF"},
        {label: "Response Rates (Minutes)", key: "", align: "center", filtered: false, sorts: false, row: 1, colSpan: true, cols: 2, bgColor: "#276BFFFF"},
        {label: "Avg", key: "avg_response_time_2nd", align: "center", filtered: false, sorts: true, row: 2, bgColor: "#276BFFFF"},
        {label: "Max", key: "max_response_time_2nd", align: "center", filtered: false, sorts: true, row: 2, bgColor: "#276BFFFF"},
        {label: "# Events", key: "total_events_3rd", align: "center", filtered: false, sorts: true, rowSpan: true, row: 1, rows: 2, bgColor: "#0B16FFFF"},
        {label: "Avg Daily", key: "avg_daily_events_3rd", align: "center", filtered: false, sorts: true, rowSpan: true, row: 1, rows: 2, bgColor: "#0B16FFFF"},
        {label: "Response Rates (Minutes)", key: "", align: "center", filtered: false, sorts: false, row: 1, colSpan: true, cols: 2, bgColor: "#0B16FFFF"},
        {label: "Avg", key: "avg_response_time_3rd", align: "center", filtered: false, sorts: true, row: 2, bgColor: "#0B16FFFF"},
        {label: "Max", key: "max_response_time_3rd", align: "center", filtered: false, sorts: true, row: 2, bgColor: "#0B16FFFF"},
    ];

    csvHeaders = [
        {label: "Campus Name", key: "campus_name"},
        {label: "Total Events", key: "total_events"},
        {label: "Avg Daily Events", key: "avg_daily_events"},
        {label: "Avg Response Time", key: "ave_response_time"},
        {label: "1st Shift Total Events", key: "total_events_1st"},
        {label: "1st Shift Daily Events", key: "avg_daily_events_1st"},
        {label: "1st Shift Total Response", key: "total_response_time_1st"},
        {label: "1st Shift Avg Response", key: "avg_response_time_1st"},
        {label: "1st Shift Max Response", key: "max_response_time_1st"},
        {label: "1st Shift Min Response", key: "min_response_time_1st"},
        {label: "2nd Shift Total Events", key: "total_events_2nd"},
        {label: "2nd Shift Daily Events", key: "avg_daily_events_2nd"},
        {label: "2nd Shift Total Response", key: "total_response_time_2nd"},
        {label: "2nd Shift Avg Response", key: "avg_response_time_2nd"},
        {label: "2nd Shift Max Response", key: "max_response_time_2nd"},
        {label: "2nd Shift Min Response", key: "min_response_time_2nd"},
        {label: "3rd Shift Total Events", key: "total_events_3rd"},
        {label: "3rd Shift Daily Events", key: "avg_daily_events_3rd"},
        {label: "3rd Shift Total Response", key: "total_response_time_3rd"},
        {label: "3rd Shift Avg Response", key: "avg_response_time_3rd"},
        {label: "3rd Shift Max Response", key: "max_response_time_3rd"},
        {label: "3rd Shift Min Response", key: "min_response_time_3rd"}
    ];

    areaTypeHeaders = [
        {label: "Area Type", key: "area_type_name", align: "left"},
        {label: "Description", key: "area_type_description", align: "left"},
    ];
    deviceCatHeaders = [
        {label: "Category", key: "device_category_short_name", align: "left"},
    ];

    if (ReactSession.get("PAL") !== undefined){
        let bData = AES.decrypt(ReactSession.get("PAL"), process.env.REACT_APP_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    // Review Data Variables
    const [corpId, setCorpId] = useState(dData.corp);
    const [compareTotal, setCompareTotal] = useState(0);
    const [compareAvgD, setCompareAvgD] = useState(0);
    const [compareAvgR, setCompareAvgR] = useState(0);
    const [campusTotal, setCampusTotal] = useState(0);
    const [campusAvgD, setCampusAvgD] = useState(0);
    const [campusAvgR, setCampusAvgR] = useState(0);
    const [dataOrigin, setDataOrigin] = useState([]);
    const [activeData, setActiveData] = useState([]);
    const [tableRows, setTableRows] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [headerFilters, setHeaderFilters] = useState([]);
    const [campusId, setCampusId] = useState(null);
    const [campusName, setCampusName] = useState("");
    const [storedIndex, setStoredIndex] = useState(0);
    const [page, setPage] = useState(1);
    const [storePage, setStorePage] = useState(1);
    const [perPage, setPerPage] = useState(dData.perPage);
    const [ppRules, setPRules] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });
    const [sorter, setSorter] = useState({
        sortColumn: "campus_name",
        sortOrder: "asc"
    });
    // Trends Data Variables
    const [trendsOrigin, setTrendsOrigin] = useState([]);
    const [activeTrends, setActiveTrends] = useState([]);
    const [kpi, setKpi] = useState("response");
    const [kpiLabel, setKpiLabel] = useState("Average Response Time");
    const [trendsRows, setTrendsRows] = useState([]);
    const [trendsLoaded, setTrendsLoaded] = useState(false);
    const [trendsHeaderFilters, setTrendsHeaderFilters] = useState([]);
    const [trendsPage, setTrendsPage] = useState(1);
    const [trendsStoredPage, setTrendsStoredPage] = useState(1);
    const [reloadCampus, setReloadCampus] = useState(0);
    const [week1start, setWeek1Start] = useState("");
    const [week2start, setWeek2Start] = useState("");
    const [week3start, setWeek3Start] = useState("");
    const [week4start, setWeek4Start] = useState("");
    const [week5start, setWeek5Start] = useState("");
    const [week6start, setWeek6Start] = useState("");
    const [week7start, setWeek7Start] = useState("");
    const [week8start, setWeek8Start] = useState("");
    const [week9start, setWeek9Start] = useState("");
    const [week10start, setWeek10Start] = useState("");
    const [week11start, setWeek11Start] = useState("");
    const [week12start, setWeek12Start] = useState("");
    const [week1end, setWeek1End] = useState("");
    const [week2end, setWeek2End] = useState("");
    const [week3end, setWeek3End] = useState("");
    const [week4end, setWeek4End] = useState("");
    const [week5end, setWeek5End] = useState("");
    const [week6end, setWeek6End] = useState("");
    const [week7end, setWeek7End] = useState("");
    const [week8end, setWeek8End] = useState("");
    const [week9end, setWeek9End] = useState("");
    const [week10end, setWeek10End] = useState("");
    const [week11end, setWeek11End] = useState("");
    const [week12end, setWeek12End] = useState("");
    const [trendLineLabels, setTrendLineLabels] = useState([]);
    const [trendLineData, setTrendLineData] = useState([]);
    const [trendAxisLabels, setTrendAxisLabels] = useState([]);
    const [trendsPPRules, setTrendsPPRules] = useState({
        start: 0,
        end: 1,
        beginDot: false,
        endDot: false,
        pageMin: 1,
        pageMax: 1,
        max: 1
    });
    const [trendsSorter, setTrendsSorter] = useState({
        sortColumn: "campus_name",
        sortOrder: "asc"
    });
    // Hour Chart variables
    const [hourData, setHourData] = useState([]);
    const [hourDataLoaded, setHourDataLoaded] = useState(false);
    // Filter page variables
    const [filterTabItem, setFilterTabItem] = useState("areaType");
    const [filterCount,setFilterCount] = useState(0);
    // Area Type Filter Table Variables
    const [areaTypeFilterList, setAreaTypeFilterList] = useState([]);
    const [areaTypeFilterLabels, setAreaTypeFilterLabels] = useState([]);
    const [areaTypeOriginData, setAreaTypeOriginData] = useState([]);
    const [areaTypeTableRows, setAreaTypeTableRows] = useState([]);
    const [areaTypeDataCnt, setAreaTypeDataCnt] = useState(0);
    const [areaTypeIdList, setAreaTypeIdList] = useState([]);
    const [areaTypeSearch, setAreaTypeSearch] = useState("");
    const [areaTypeSorter, setAreaTypeSorter] = useState({
        sortColumn: "description",
        sortOrder: "asc"
    });
    // Device Category Filter Table Variables
    const [devCatFilterList, setDevCatFilterList] = useState([]);
    const [devCatFilterLabels, setDevCatFilterLabels] = useState([]);
    const [devCatOriginData, setDevCatOriginData] = useState([]);
    const [devCatTableRows, setDevCatTableRows] = useState([]);
    const [devCatDataCnt, setDevCatDataCnt] = useState(0);
    const [devCatIdList, setDevCatIdList] = useState([]);
    const [devCatSearch, setDevCatSearch] = useState("");
    const [devCatSorter, setDevCatSorter] = useState({
        sortColumn: "device_category_short_name",
        sortOrder: "asc"
    });
    // Response Rate Filter Variables
    const [responseFilterList, setResponseFilterList] = useState([false, "lt", 60]);
    const [responseFilterLabels, setResponseFilterLabels] = useState(["Response time", "less than", "60 minutes"]);
    // Page General Variables
    const [count, setCount] = useState("");
    const [search, setSearch] = useState("");
    const [tabItem, setTabItem] = useState("init");
    const [csvLink, setLink] = useState({
        filename: "corporate_dash.csv",
        headers: [],
        data: []
    });
    const [csvButton, setCSVButton] = useState(
        <CSVLink {...csvLink} uFEFF={false}>
            <Button text={"Export"} icon={true} iconClass={"fe fe-download me-2"}
                    class={"btn btn-primary ms-2 px-4 mt-1"}/>
        </CSVLink>);

    if (kpi === "response"){
        trendsHeaderData = [
            {label: "Campus Name", key: "campus_name", align: "left", filtered: true, sorts: true},
            {label: `${week1start}-${week1end}`, key: "avg_response_time_1", align: "center", filtered: false, sorts: true},
            {label: `${week2start}-${week2end}`, key: "avg_response_time_2", align: "center", filtered: false, sorts: true},
            {label: `${week3start}-${week3end}`, key: "avg_response_time_3", align: "center", filtered: false, sorts: true},
            {label: `${week4start}-${week4end}`, key: "avg_response_time_4", align: "center", filtered: false, sorts: true},
            {label: `${week5start}-${week5end}`, key: "avg_response_time_5", align: "center", filtered: false, sorts: true},
            {label: `${week6start}-${week6end}`, key: "avg_response_time_6", align: "center", filtered: false, sorts: true},
            {label: `${week7start}-${week7end}`, key: "avg_response_time_7", align: "center", filtered: false, sorts: true},
            {label: `${week8start}-${week8end}`, key: "avg_response_time_8", align: "center", filtered: false, sorts: true},
            {label: `${week9start}-${week9end}`, key: "avg_response_time_9", align: "center", filtered: false, sorts: true},
            {label: `${week10start}-${week10end}`, key: "avg_response_time_10", align: "center", filtered: false, sorts: true},
            {label: `${week11start}-${week11end}`, key: "avg_response_time_11", align: "center", filtered: false, sorts: true},
            {label: `${week12start}-${week12end}`, key: "avg_response_time_12", align: "center", filtered: false, sorts: true}
        ];
        csvTrendsHeaders = [
            {label: "Campus Name", key: "campus_name"},
            {label: `${week1start}-${week1end}`, key: "avg_response_time_1"},
            {label: `${week2start}-${week2end}`, key: "avg_response_time_2"},
            {label: `${week3start}-${week3end}`, key: "avg_response_time_3"},
            {label: `${week4start}-${week4end}`, key: "avg_response_time_4"},
            {label: `${week5start}-${week5end}`, key: "avg_response_time_5"},
            {label: `${week6start}-${week6end}`, key: "avg_response_time_6"},
            {label: `${week7start}-${week7end}`, key: "avg_response_time_7"},
            {label: `${week8start}-${week8end}`, key: "avg_response_time_8"},
            {label: `${week9start}-${week9end}`, key: "avg_response_time_9"},
            {label: `${week10start}-${week10end}`, key: "avg_response_time_10"},
            {label: `${week11start}-${week11end}`, key: "avg_response_time_11"},
            {label: `${week12start}-${week12end}`, key: "avg_response_time_12"}
        ];
    }else if (kpi === "daily"){
        trendsHeaderData = [
            {label: "Campus Name", key: "campus_name", align: "left", filtered: true, sorts: true},
            {label: `${week1start}-${week1end}`, key: "avg_daily_events_1", align: "center", filtered: false, sorts: true},
            {label: `${week2start}-${week2end}`, key: "avg_daily_events_2", align: "center", filtered: false, sorts: true},
            {label: `${week3start}-${week3end}`, key: "avg_daily_events_3", align: "center", filtered: false, sorts: true},
            {label: `${week4start}-${week4end}`, key: "avg_daily_events_4", align: "center", filtered: false, sorts: true},
            {label: `${week5start}-${week5end}`, key: "avg_daily_events_5", align: "center", filtered: false, sorts: true},
            {label: `${week6start}-${week6end}`, key: "avg_daily_events_6", align: "center", filtered: false, sorts: true},
            {label: `${week7start}-${week7end}`, key: "avg_daily_events_7", align: "center", filtered: false, sorts: true},
            {label: `${week8start}-${week8end}`, key: "avg_daily_events_8", align: "center", filtered: false, sorts: true},
            {label: `${week9start}-${week9end}`, key: "avg_daily_events_9", align: "center", filtered: false, sorts: true},
            {label: `${week10start}-${week10end}`, key: "avg_daily_events_10", align: "center", filtered: false, sorts: true},
            {label: `${week11start}-${week11end}`, key: "avg_daily_events_11", align: "center", filtered: false, sorts: true},
            {label: `${week12start}-${week12end}`, key: "avg_daily_events_12", align: "center", filtered: false, sorts: true}
        ];
        csvTrendsHeaders = [
            {label: "Campus Name", key: "campus_name"},
            {label: `${week1start}-${week1end}`, key: "avg_daily_events_1"},
            {label: `${week2start}-${week2end}`, key: "avg_daily_events_2"},
            {label: `${week3start}-${week3end}`, key: "avg_daily_events_3"},
            {label: `${week4start}-${week4end}`, key: "avg_daily_events_4"},
            {label: `${week5start}-${week5end}`, key: "avg_daily_events_5"},
            {label: `${week6start}-${week6end}`, key: "avg_daily_events_6"},
            {label: `${week7start}-${week7end}`, key: "avg_daily_events_7"},
            {label: `${week8start}-${week8end}`, key: "avg_daily_events_8"},
            {label: `${week9start}-${week9end}`, key: "avg_daily_events_9"},
            {label: `${week10start}-${week10end}`, key: "avg_daily_events_10"},
            {label: `${week11start}-${week11end}`, key: "avg_daily_events_11"},
            {label: `${week12start}-${week12end}`, key: "avg_daily_events_12"}
        ];
    }else{
        trendsHeaderData = [
            {label: "Campus Name", key: "campus_name", align: "left", filtered: true, sorts: true},
            {label: `${week1start}-${week1end}`, key: "total_events_1", align: "center", filtered: false, sorts: true},
            {label: `${week2start}-${week2end}`, key: "total_events_2", align: "center", filtered: false, sorts: true},
            {label: `${week3start}-${week3end}`, key: "total_events_3", align: "center", filtered: false, sorts: true},
            {label: `${week4start}-${week4end}`, key: "total_events_4", align: "center", filtered: false, sorts: true},
            {label: `${week5start}-${week5end}`, key: "total_events_5", align: "center", filtered: false, sorts: true},
            {label: `${week6start}-${week6end}`, key: "total_events_6", align: "center", filtered: false, sorts: true},
            {label: `${week7start}-${week7end}`, key: "total_events_7", align: "center", filtered: false, sorts: true},
            {label: `${week8start}-${week8end}`, key: "total_events_8", align: "center", filtered: false, sorts: true},
            {label: `${week9start}-${week9end}`, key: "total_events_9", align: "center", filtered: false, sorts: true},
            {label: `${week10start}-${week10end}`, key: "total_events_10", align: "center", filtered: false, sorts: true},
            {label: `${week11start}-${week11end}`, key: "total_events_11", align: "center", filtered: false, sorts: true},
            {label: `${week12start}-${week12end}`, key: "total_events_12", align: "center", filtered: false, sorts: true}
        ];
        csvTrendsHeaders = [
            {label: "Campus Name", key: "campus_name"},
            {label: `${week1start}-${week1end}`, key: "total_events_1"},
            {label: `${week2start}-${week2end}`, key: "total_events_2"},
            {label: `${week3start}-${week3end}`, key: "total_events_3"},
            {label: `${week4start}-${week4end}`, key: "total_events_4"},
            {label: `${week5start}-${week5end}`, key: "total_events_5"},
            {label: `${week6start}-${week6end}`, key: "total_events_6"},
            {label: `${week7start}-${week7end}`, key: "total_events_7"},
            {label: `${week8start}-${week8end}`, key: "total_events_8"},
            {label: `${week9start}-${week9end}`, key: "total_events_9"},
            {label: `${week10start}-${week10end}`, key: "total_events_10"},
            {label: `${week11start}-${week11end}`, key: "total_events_11"},
            {label: `${week12start}-${week12end}`, key: "total_events_12"}
        ];
    }

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setCount(count => count - 1);
        }, 1000);
        if (count <= 0){
            ApiRequester({reqEndpoint: "get-mysql-report", rep_type: "getcorpportalfilters",
                                corporation_id: corpId, device_category_filter: "1", area_type_filter: "1"}).then(data => {
                setDevCatOriginData(() => data?.device_categories?.length > 0 ? data.device_categories : []);
                setAreaTypeOriginData(() => data?.area_types?.length > 0 ? data.area_types : []);
            });
            ApiRequester({reqEndpoint: "get-mysql-report", rep_type: "corpdashboardstatsv2",
                                corporation_id: corpId, area_type_filter: areaTypeFilterList.join(","),
                                device_category_filter: devCatFilterList.join(","),
                                resp_filter_items: responseFilterList}).then(data => {
                setDataOrigin(data?.records ? data.records : []);
                setDataLoaded(true);
                if (data?.records?.length > 0 && campusId === null){
                    setCampusId(data.records[0].campus_id);
                    setCampusName(data.records[0].campus_name);
                    setCampusTotal(data.records[0].total_events);
                    setCampusAvgD(data.records[0].avg_daily_events);
                    setCampusAvgR(data.records[0].avg_response_time);
                    setCompareTotal(data?.compare?.total_events);
                    setCompareAvgD(data?.compare?.avg_daily_events);
                    setCompareAvgR(data?.compare?.avg_response_time);
                }
            });
            ApiRequester({reqEndpoint: "get-mysql-report", rep_type: "corpdashboardtrends",
                                corporation_id: corpId, area_type_filter: areaTypeFilterList.join(","),
                                device_category_filter: devCatFilterList.join(","),
                                resp_filter_items: responseFilterList}).then(data => {
                setTrendsOrigin(data?.records ? data.records : []);
                setTrendsLoaded(true);
                setWeek1Start(data?.week1_start ? formatDateToMMDD(data.week1_start) : "");
                setWeek1End(data?.week1_end ? formatDateToMMDD(data.week1_end) : "");
                setWeek2Start(data?.week2_start ? formatDateToMMDD(data.week2_start) : "");
                setWeek2End(data?.week2_end ? formatDateToMMDD(data.week2_end) : "");
                setWeek3Start(data?.week3_start ? formatDateToMMDD(data.week3_start) : "");
                setWeek3End(data?.week3_end ? formatDateToMMDD(data.week3_end) : "");
                setWeek4Start(data?.week4_start ? formatDateToMMDD(data.week4_start) : "");
                setWeek4End(data?.week4_end ? formatDateToMMDD(data.week4_end) : "");
                setWeek5Start(data?.week5_start ? formatDateToMMDD(data.week5_start) : "");
                setWeek5End(data?.week5_end ? formatDateToMMDD(data.week5_end) : "");
                setWeek6Start(data?.week6_start ? formatDateToMMDD(data.week6_start) : "");
                setWeek6End(data?.week6_end ? formatDateToMMDD(data.week6_end) : "");
                setWeek7Start(data?.week7_start ? formatDateToMMDD(data.week7_start) : "");
                setWeek7End(data?.week7_end ? formatDateToMMDD(data.week7_end) : "");
                setWeek8Start(data?.week8_start ? formatDateToMMDD(data.week8_start) : "");
                setWeek8End(data?.week8_end ? formatDateToMMDD(data.week8_end) : "");
                setWeek9Start(data?.week9_start ? formatDateToMMDD(data.week9_start) : "");
                setWeek9End(data?.week9_end ? formatDateToMMDD(data.week9_end) : "");
                setWeek10Start(data?.week10_start ? formatDateToMMDD(data.week10_start) : "");
                setWeek10End(data?.week10_end ? formatDateToMMDD(data.week10_end) : "");
                setWeek11Start(data?.week11_start ? formatDateToMMDD(data.week11_start) : "");
                setWeek11End(data?.week11_end ? formatDateToMMDD(data.week11_end) : "");
                setWeek12Start(data?.week12_start ? formatDateToMMDD(data.week12_start) : "");
                setWeek12End(data?.week12_end ? formatDateToMMDD(data.week12_end) : "");
            });
            setCount(count => 600);
        }
        return () => clearInterval(interval);
    }, [count, devCatFilterList, areaTypeFilterList, responseFilterList]);

    useEffect(() => {
        if (![null, undefined].includes(campusId)){
            if (campusId === 0){
                ApiRequester({reqEndpoint: "get-mysql-report", rep_type: "corpdashboardhourchart",
                            corporation_id: corpId, area_type_filter: areaTypeFilterList.join(","),
                            device_category_filter: devCatFilterList.join(","),
                            resp_filter_items: responseFilterList}).then(data => {
                    setHourData(data !== undefined ? data : {});
                    setHourDataLoaded(true);
                });
            }else{
                ApiRequester({reqEndpoint: "get-mysql-report", rep_type: "dashboardhourchart",
                                campus_id: campusId, area_type_filter: areaTypeFilterList.join(","),
                                device_category_filter: devCatFilterList.join(","),
                                resp_filter_items: responseFilterList}).then(data => {
                    setHourData(data !== undefined ? data : {});
                    setHourDataLoaded(true);
                });
            }
        }
    }, [campusId, devCatFilterList, areaTypeFilterList, responseFilterList]);

    useEffect(() => {
        if (tabItem === "first"){
            setLink(prevState => {
                return {...prevState,
                    headers: csvHeaders,
                    data: dataOrigin}
            });
        }else if (tabItem === "second"){
            setLink(prevState => {
                return {...prevState,
                    headers: csvTrendsHeaders,
                    data: trendsOrigin}
            });
        }
    }, [dataOrigin, trendsOrigin, tabItem, kpi]);

    useEffect(() => {
        setCSVButton(
            <CSVLink {...csvLink} uFEFF={false}>
                <Button text={"Export"} icon={true} iconClass={"fe fe-download me-2"}
                        class={"btn btn-primary ms-2 px-4 mt-1"}/>
            </CSVLink>
        );
    }, [csvLink]);

    useEffect(() => {
        if (![dataLoaded].includes(false)){
            setPageLoaded(true);
            setTabItem("first");
        }
    }, [dataLoaded]);

    useEffect(() => {
        if (pageLoaded && campusId !== null){
            setCampus(campusId);
            setReloadCampus(false);
        }
    }, [pageLoaded, tabItem, kpi, reloadCampus, trendsOrigin, dataOrigin]);

    useEffect(() => {
        let tmpData, pRules, searchKeys;

        let filteredData = headerFilterFunc(dataOrigin, headerFilters, headerData);

        searchKeys = ["campus_name"];
        tmpData = searchFunc(search, filteredData, searchKeys)

        pRules = paginateData(tmpData, page, perPage);
        if (search && page > pRules.pageMax){
            setPage(pRules.pageMax);
        }else if (!search){
            setPage(storePage);
        }
        setPRules(pRules);
        setActiveData(tmpData);
    }, [sorter, dataOrigin, headerFilters, search]);

    useEffect(() => {
        let tmpData, pRules, searchKeys;

        let filteredData = headerFilterFunc(trendsOrigin, trendsHeaderFilters, trendsHeaderData);

        searchKeys = ["campus_name"];
        tmpData = searchFunc(search, filteredData, searchKeys)

        pRules = paginateData(tmpData, trendsPage, perPage);
        if (search && page > pRules.pageMax){
            setTrendsPage(pRules.pageMax);
        }else if (!search){
            setTrendsPage(trendsStoredPage);
        }
        setTrendsPPRules(pRules);
        setActiveTrends(tmpData);
    }, [trendsSorter, trendsOrigin, trendsHeaderFilters, search]);

    useEffect(() => {
        let pRules = paginateData(activeData, page, perPage);
        setPRules(pRules);
        if (activeData.length > 0) {
            activeData.sort((a, b) => sortFunc(a, b, sorter.sortColumn, sorter.sortOrder));
        }
        setTableRows(<TableBody start={pRules.start} end={pRules.end} tableData={activeData} checkbox={false}
                                writeAccess={false} unk={"a-"} actionAppearance={() => {}} radioSelected={campusId}
                                tableHeaders={headerData} editModal={() => {}} modal={false}
                                parentComponent={"CorpDash"} dData={dData} radioId={"r-"} radioKey={"campus_id"}
                                radio={true} radioFunc={(item) => setCampus(item)} />);
    }, [activeData, sorter, page, perPage, campusId]);

    useEffect(() => {
        let pRules = paginateData(activeTrends, page, perPage);
        setTrendsPPRules(pRules);
        if (activeTrends.length > 0) {
            activeTrends.sort((a, b) => sortFunc(a, b, trendsSorter.sortColumn, trendsSorter.sortOrder));
        }
        setTrendsRows(<TableBody start={pRules.start} end={pRules.end} tableData={activeTrends} checkbox={false}
                                writeAccess={false} unk={"a-"} actionAppearance={() => {}} radioSelected={campusId}
                                tableHeaders={trendsHeaderData} editModal={() => {}} modal={false}
                                parentComponent={"CorpDash"} dData={dData} radioId={"r2-"} radioKey={"campus_id"}
                                radio={true} radioFunc={(item) => setCampus(item)} />);
    }, [activeTrends, trendsSorter, trendsPage, perPage, kpi, campusId]);

    useEffect(() => {
        let tmpData, searchKeys;

        searchKeys = ["area_type_name", "area_type_description"];
        tmpData = searchFunc(areaTypeSearch, areaTypeOriginData, searchKeys)

        setAreaTypeDataCnt(tmpData.length);
        tmpData.sort((a, b) => sortFunc(a, b, areaTypeSorter.sortColumn, areaTypeSorter.sortOrder));
        setAreaTypeTableRows(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={true} writeAccess={true}
                                        actionAppearance={() => {}} tableHeaders={areaTypeHeaders} checkboxId={"uCheckAreaType"}
                                        parentComponent={"EventReports"} dData={dData} checkboxlist={areaTypeIdList}
                                        modal={false} editModal={() => {}} unk={"area-type-x-"}
                                        setCheckboxId={(value) => {setAreaTypeIdList(value)}} checkidkey={"area_type_id"} />);
    }, [areaTypeOriginData, areaTypeSorter, areaTypeIdList, areaTypeSearch]);

    useEffect(() => {
        let tmpData, searchKeys;

        searchKeys = ["device_category_short_name"];
        tmpData = searchFunc(devCatSearch, devCatOriginData, searchKeys)

        setDevCatDataCnt(tmpData.length);
        tmpData.sort((a, b) => sortFunc(a, b, devCatSorter.sortColumn, devCatSorter.sortOrder));
        setDevCatTableRows(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={true} writeAccess={true}
                                   actionAppearance={() => {}} tableHeaders={deviceCatHeaders} checkboxId={"uCheckDevCat"}
                                   parentComponent={"EventReports"} dData={dData} checkboxlist={devCatIdList}
                                   modal={false} editModal={() => {}} unk={"device-cat-x-"}
                                   setCheckboxId={(value) => {setDevCatIdList(value)}} checkidkey={"device_category_id"} />);
    }, [devCatOriginData, devCatSorter, devCatIdList, devCatSearch]);

    function setCampus(citem){
        let activeRec = dataOrigin?.filter((item) => {return item.campus_id === citem});
        let at = trendsOrigin?.filter((item) => {return item.campus_id === citem});
        setCampusId(citem);
        setCampusName(activeRec && activeRec?.length > 0 ? activeRec[0]?.campus_name : "");
        setCampusTotal(activeRec && activeRec?.length > 0 ? activeRec[0]?.total_events : 0);
        setCampusAvgD(activeRec && activeRec?.length > 0 ? activeRec[0]?.avg_daily_events : 0);
        setCampusAvgR(activeRec && activeRec?.length > 0 ? activeRec[0]?.avg_response_time : 0);
        if (at?.length > 0){
            if (kpi === "response"){
                setTrendLineData([[at[0].avg_response_time_1, at[0].avg_response_time_2, at[0].avg_response_time_3,
                    at[0].avg_response_time_4, at[0].avg_response_time_5, at[0].avg_response_time_6, at[0].avg_response_time_7,
                    at[0].avg_response_time_8, at[0].avg_response_time_9, at[0].avg_response_time_10, at[0].avg_response_time_11,
                    at[0].avg_response_time_12]]);
            }else if (kpi === "daily"){
                setTrendLineData([[at[0].avg_daily_events_1, at[0].avg_daily_events_2, at[0].avg_daily_events_3,
                    at[0].avg_daily_events_4, at[0].avg_daily_events_5, at[0].avg_daily_events_6, at[0].avg_daily_events_7,
                    at[0].avg_daily_events_8, at[0].avg_daily_events_9, at[0].avg_daily_events_10, at[0].avg_daily_events_11,
                    at[0].avg_daily_events_12]]);
            }else{
                setTrendLineData([[at[0].total_events_1, at[0].total_events_2, at[0].total_events_3,
                    at[0].total_events_4, at[0].total_events_5, at[0].total_events_6, at[0].total_events_7,
                    at[0].total_events_8, at[0].total_events_9, at[0].total_events_10, at[0].total_events_11,
                    at[0].total_events_12]]);
            }
            setTrendLineLabels([kpiLabel]);
            setTrendAxisLabels([`${week1start}-${week1end}`, `${week2start}-${week2end}`,
                `${week3start}-${week3end}`, `${week4start}-${week4end}`, `${week5start}-${week5end}`,
                `${week6start}-${week6end}`, `${week7start}-${week7end}`, `${week8start}-${week8end}`,
                `${week9start}-${week9end}`, `${week10start}-${week10end}`, `${week11start}-${week11end}`,
                `${week12start}-${week12end}`]);
        }
    }

    function clearFilters() {
        // Function used in filter modal to clear all toggled checkboxes across all tabs.
        setAreaTypeIdList([]);
        setDevCatIdList([]);
        document.getElementById("uCheckHead2").checked = false;
        document.getElementById("uCheckHead3").checked = false;
        document.getElementById("response-on").checked = false;
        document.getElementById("response-operator").value = "lt";
        document.getElementById("response-value").value = 60;
    }

    function showFilterModal() {
        // Function that preps and populates the filter modal with the checks when called based on stored session.
        setAreaTypeIdList(areaTypeFilterList);
        document.getElementById("uCheckHead2").checked = areaTypeFilterList.length === areaTypeOriginData.length;
        setDevCatIdList(devCatFilterList);
        document.getElementById("uCheckHead3").checked = devCatFilterList.length === devCatOriginData.length;
        document.getElementById("response-on").checked = responseFilterList[0]
        document.getElementById("response-operator").value = responseFilterList[1]
        document.getElementById("response-value").value = responseFilterList[2]
        showModal("filtermodal2");
    }

    function filterSubmit2(){
        // Function used to set filters to vars on submit from filter modal.
        let areaTypeLabels = [], devCatLabels = [], respItems = [], respLabels = [];
        handleSubmitActions("filterSubmit2", "loadFilterSubmit2");

        for (let i=0; i < areaTypeOriginData?.length; i++){
            if (areaTypeIdList.includes(areaTypeOriginData[i]?.area_type_id?.toString())){
                areaTypeLabels.push(areaTypeOriginData[i]?.area_type_name);
            }
        }
        for (let i=0; i < devCatOriginData?.length; i++){
            if (devCatIdList.includes(devCatOriginData[i]?.device_category_id?.toString())){
                devCatLabels.push(devCatOriginData[i]?.device_category_short_name);
            }
        }

        respItems[0] = document.getElementById("response-on").checked;
        respItems[1] = document.getElementById("response-operator").value;
        respItems[2] = document.getElementById("response-value").value;

        if (respItems[0]){
            respLabels[0] = "Response Time";
            if (respItems[1] === "lt"){
                respLabels[1] = "less than";
            }else if (respItems[1] === "gt"){
                respLabels[1] = "greater than";
            }else{
                respLabels[1] = "equal to";
            }
            respLabels[2] = respItems[2].toString();
        }
        setResponseFilterList(respItems);
        setResponseFilterLabels(respLabels);
        setAreaTypeFilterList(areaTypeIdList);
        setAreaTypeFilterLabels(areaTypeLabels);
        setDevCatFilterList(devCatIdList);
        setDevCatFilterLabels(devCatLabels);
        formSuccess("Filters saved, report updating", "filterSubmit2", "loadFilterSubmit2", "cancelFilterBtn2");
        setCount(() => 0);
    }

    function showFilterLabels(){
        let filterText = "";
        if (areaTypeFilterLabels.length > 0){
            filterText = filterText + ` For ${complexDelimDisplay("", areaTypeFilterLabels.join(", "))}`;
        }
        if (devCatFilterLabels.length > 0){
            filterText = filterText + ` Using ${complexDelimDisplay("", devCatFilterLabels.join(", "))}`;
        }
        if (responseFilterList[0] === true){
            filterText = filterText + ` With ${responseFilterLabels.join(" ")}`;
        }
        return filterText;
    }

    function filtersOn(){
        return [areaTypeFilterList, devCatFilterList, responseFilterList[0]].some(filterArray => filterArray.length > 0);
    }

    const tableHeaders = <TableHeaders checkbox={false} headerData={headerData} checkAll={() => {}}
                                       writeAccess={false} sortOrder={sorter.sortOrder} checkboxHeaderId={"uCheckHead"}
                                       originData={dataOrigin} headerFiltersOn={true} sortColumn={sorter.sortColumn}
                                       sorter={sorter} setSorter={setSorter} modal={false} checkboxlist={[]}
                                       radio={true} radioHeaderId={"uRadioHead"}
                                       actionAppearance={() => {}} modal_name={""} headerFilters={headerFilters}
                                       setHeaderFilters={setHeaderFilters} setPage={setPage} rowCnt={2} />

    const trendsTableHeaders = <TableHeaders checkbox={false} headerData={trendsHeaderData} checkAll={() => {}}
                                       writeAccess={false} sortOrder={trendsSorter.sortOrder} checkboxHeaderId={"uCheckHead4"}
                                       originData={trendsOrigin} headerFiltersOn={true} sortColumn={trendsSorter.sortColumn}
                                       sorter={trendsSorter} setSorter={setTrendsSorter} modal={false} checkboxlist={[]}
                                       radio={true} radioHeaderId={"uRadioHead2"}
                                       actionAppearance={() => {}} modal_name={""} headerFilters={trendsHeaderFilters}
                                       setHeaderFilters={setTrendsHeaderFilters} setPage={setTrendsPage} />

    const areaTypeTableHeaders = <TableHeaders checkbox={true} headerData={areaTypeHeaders} checkboxlist={areaTypeIdList}
                                               checkAll={() => checkAll(0, areaTypeDataCnt ? areaTypeDataCnt : 0, areaTypeIdList, setAreaTypeIdList, "uCheckHead2", "uCheckAreaType")}
                                               writeAccess={true} sortOrder={areaTypeSorter.sortOrder} checkboxHeaderId={"uCheckHead2"}
                                               sortColumn={areaTypeSorter.sortColumn} sorter={areaTypeSorter} setSorter={setAreaTypeSorter}
                                               actionAppearance={() => {}} />
    const deviceCatTableHeaders = <TableHeaders checkbox={true} headerData={deviceCatHeaders} checkboxlist={devCatIdList}
                                                checkAll={() => checkAll(0, devCatDataCnt ? devCatDataCnt : 0, devCatIdList, setDevCatIdList, "uCheckHead3", "uCheckDevCat")}
                                                writeAccess={true} sortOrder={devCatSorter.sortOrder} checkboxHeaderId={"uCheckHead3"}
                                                sortColumn={devCatSorter.sortColumn} sorter={devCatSorter} setSorter={setDevCatSorter}
                                                actionAppearance={() => {}} />

    const headerContent = (
        <div className={"d-flex justify-content-between"}>
            <div style={{minWidth: "360px"}}>
                <button type={"button"} className={"btn btn-secondary me-4"} style={{height: "46.5px"}}
                        onClick={() => {
                            showFilterModal();
                        }}>
                    <i className={"fe fe-filter fs-3"}/>
                    {filtersOn() && <div className={"filter-caret"}></div>}
                </button>
                <div className={"form-outline d-inline-flex align-bottom ms-2"}>
                    <input type={"search"} id={"search1"} className={"form-control search-input mt-1"}
                         onKeyUp={(e) => setSearch(e.target.value)} />
                    <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left mt-1"}
                            style={{height: "42px"}} icon={true} iconClass={"fe fe-search"}/>
                </div>
                {csvButton}
            </div>
            <div>
            </div>
        </div>
    )
    return (
        <>
            <Navigation/>
            <div className={"main-content"} style={tabItem !== "init" ? {height: "calc(100vh)", overflowY: "hidden"} : {}}>
                <Header preTitle={"Dashboard"} Title={"Corporate"} subTitle={showFilterLabels()} content={headerContent} />
                <div className={"container-fluid"}>
                    <div id={"tab-line"} className={"d-flex justify-content-between"}>
                        <ul className={"nav nav-tabs nav-overflow header-tabs"}>
                            <li key={"set-first"} className={"nav-item"}>
                                <Button text={"Campus Review"} spinner={!dataLoaded}
                                        class={tabItem === "first" ? "nav-link active" : "nav-link"}
                                        onClick={() => setTabItem("first")}/>
                            </li>
                            <li key={"set-second"} className={"nav-item"}>
                                <Button text={"Campus Trends"} spinner={!trendsLoaded}
                                        class={tabItem === "second" ? "nav-link active" : "nav-link"}
                                        onClick={() => setTabItem("second")}/>
                            </li>
                        </ul>
                        <div id={"shift-legend"} className={tabItem === "first" ? "d-inline-block mt-auto" : "d-none"}>
                            <p className={"me-5"}>* Last 28 days</p>
                            <OverlayTrigger trigger={["hover", "focus"]} key={`popover-day-legend`}
                                        placement={"left"} overlay={
                                            <Popover id={`popover-overlay-day`} className={"popover1"}>
                                                <Popover.Header as="h3" className={"popover-header1 text-light"}>
                                                    <div className={"d-inline-block align-middle"}
                                                         style={{width: "1rem", height: "1rem",
                                                             backgroundColor: "#27B4FFFF", borderRadius: "4px"
                                                         }}></div>
                                                    <p className={"align-top ms-2"}>Day Shift</p>
                                                </Popover.Header>
                                                <Popover.Body className={"popover-body1"}>
                                                    <p className={"align-top ms-2"}>7AM - 3PM</p>
                                                </Popover.Body>
                                            </Popover>
                                        }>
                                        <div className={"d-inline-block"}>
                                            <div className={"d-inline-block align-middle"}
                                                 style={{
                                                     width: "1rem",
                                                     height: "1rem",
                                                     backgroundColor: "#27B4FFFF",
                                                     borderRadius: "4px"
                                                 }}></div>
                                            <p className={"align-top ms-2 me-5"} style={{cursor: "default"}}>Day</p>
                                        </div>
                            </OverlayTrigger>
                            <OverlayTrigger trigger={["hover", "focus"]} key={`popover-evening-legend`}
                                            placement={"left"} overlay={
                                                <Popover id={`popover-overlay-evening`} className={"popover1"}>
                                                    <Popover.Header as="h3" className={"popover-header1 text-light"}>
                                                        <div className={"d-inline-block align-middle"}
                                                             style={{width: "1rem", height: "1rem",
                                                                 backgroundColor: "#276BFFFF", borderRadius: "4px"
                                                             }}></div>
                                                        <p className={"align-top ms-2"}>Evening Shift</p>
                                                    </Popover.Header>
                                                    <Popover.Body className={"popover-body1"}>
                                                        <p className={"align-top ms-2"}>3PM - 11PM</p>
                                                    </Popover.Body>
                                                </Popover>
                                            }>
                                    <div className={"d-inline-block"}>
                                        <div className={"d-inline-block align-middle"}
                                             style={{width: "1rem", height: "1rem", backgroundColor: "#276BFFFF", borderRadius: "4px"}}></div>
                                        <p className={"align-top ms-2 me-5"}>Evening</p>
                                    </div>
                            </OverlayTrigger>
                            <OverlayTrigger trigger={["hover", "focus"]} key={`popover-night-legend`}
                                            placement={"left"} overlay={
                                                <Popover id={`popover-overlay-night`} className={"popover1"}>
                                                    <Popover.Header as="h3" className={"popover-header1 text-light"}>
                                                        <div className={"d-inline-block align-middle"}
                                                             style={{
                                                                 width: "1rem", height: "1rem",
                                                                 backgroundColor: "#0B16FFFF", borderRadius: "4px"
                                                             }}></div>
                                                        <p className={"align-top ms-2"}>Night Shift</p>
                                                    </Popover.Header>
                                                    <Popover.Body className={"popover-body1"}>
                                                        <p className={"align-top ms-2"}>11PM - 7AM</p>
                                                    </Popover.Body>
                                                </Popover>
                                            }>
                                <div className={"d-inline-block"}>
                                    <div className={"d-inline-block align-middle"}
                                         style={{width: "1rem", height: "1rem", backgroundColor: "#0B16FFFF", borderRadius: "4px"}}></div>
                                    <p className={"align-top ms-2 me-5"}>Night</p>
                                </div>
                            </OverlayTrigger>
                        </div>
                        <div id={"kpi-selector"} className={tabItem === "second" ? "d-inline-block mt-auto mb-2 me-4" : "d-none"}>
                            <div className={"border rounded-3 px-3 pt-3 pb-2"} style={{backgroundColor: "white", boxShadow: "0 4px 16px rgba(0,0,0,0.08)", minWidth: "320px"}}>
                                <h4 className={"text-center text-muted"}>KPI Selection</h4>
                                <div style={{display: "flex", flexDirection: "row", gap: "12px"}}>
                                    <div className={"form-check"}>
                                        <input className={"form-check-input"} type={"radio"} name={"kpiRadio"} id={"kpi-response"} value={"response"}
                                               checked={kpi === "response"} onChange={(e) => {
                                            setKpi(e.target.value);
                                            setKpiLabel("Average Response Time");
                                        }}/>
                                        <label className={"form-check-label"} htmlFor={"kpi-response"}
                                               style={{fontSize: "0.85rem", color: "#495057"}}>
                                            Average Response Time
                                        </label>
                                    </div>
                                    <div className={"form-check"}>
                                        <input className={"form-check-input"} type={"radio"} name={"kpiRadio"} id={"kpi-daily"} value={"daily"}
                                               checked={kpi === "daily"} onChange={(e) => {
                                                   setKpi(e.target.value);
                                                   setKpiLabel("Average Daily Events");
                                               }}/>
                                        <label className={"form-check-label"} htmlFor={"kpi-daily"}
                                               style={{fontSize: "0.85rem", color: "#495057"}}>
                                            Average Daily Events
                                        </label>
                                    </div>
                                    <div className={"form-check"}>
                                        <input className={"form-check-input"} type={"radio"} name={"kpiRadio"} id={"kpi-total"} value={"total"}
                                               checked={kpi === "total"} onChange={(e) => {
                                                   setKpi(e.target.value);
                                                   setKpiLabel("Total Events");
                                               }}/>
                                        <label className={"form-check-label"} htmlFor={"kpi-total"}
                                               style={{fontSize: "0.85rem", color: "#495057"}}>
                                            Total Events
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={tabItem === "init" ? "d-block" : "d-none"}>
                        <TableSkeleton />
                    </div>
                    <div className={tabItem === "first" ? "d-block" : "d-none"}
                         style={isBannerPresent() ? {height: "calc(100vh - 330px)", overflow: "hidden"} : {height: "calc(100vh - 295px)", overflow: "hidden"}}>
                        <div style={{height: "50%", overflow: "auto", borderBottom: "2px solid #dee2e6"}}>
                            <table className={"table table-sm table-white table-hover"} id={"review-table"}>
                                <thead style={{position: "sticky", top: "0", zIndex: "1001",
                                                backgroundColor: "white"}}>
                                    {tableHeaders}
                                </thead>
                                <tbody id={"tBody"}>
                                    {tableRows}
                                </tbody>
                            </table>
                        </div>
                        <div id={"review-chart"} style={{height: "50%", backgroundColor: "#f8f9fa",
                            border: "1px solid #dee2e6", display: "flex", gap: "8px", padding: "8px"}}>
                            <div style={{flex: "1", backgroundColor: "white", 
                                        borderRadius: "12px", padding: "20px", position: "relative", minWidth: "0", display: "flex", flexDirection: "column", 
                                        boxShadow: "0 8px 32px rgba(0,0,0,0.08)", overflow: "hidden", border: "1px solid #dee2e6"}}>
                                <h6 style={{margin: "0 0 20px 0", textAlign: "center", color: "#495057", fontSize: ".9rem", fontWeight: "600",
                                           position: "relative", zIndex: "1"}}>Events by Hour for <strong>{campusName}</strong> Last 28 Days</h6>
                                <div style={{flex: "1", minHeight: "0", position: "relative", zIndex: "1"}}>
                                    {hourDataLoaded && hourData ? (
                                        <HourlyLineAndBarChart
                                            labels={hourData?.labels ? hourData.labels : ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12",
                                                            "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"]}
                                            x_axis={true}
                                            x_axis_title={"Time of the Day"}
                                            bar_axis={true}
                                            bar_axis_title={"Total Alarms"}
                                            bar_color={"#0081C7"}
                                            line_axis={true}
                                            line_axis_title={"Average Response Time"}
                                            line_color={"#BE4D25"}
                                            bar_data={hourData?.events ? hourData.events : []}
                                            line_data={hourData?.responses ? hourData.responses : []}
                                            bar_annotation={true}
                                            line_annotation={true}
                                            bar_annotation_value={hourData?.avgValue ? hourData.avgValue : 0}
                                            line_annotation_value={hourData?.avgResp ? hourData.avgResp : 0}
                                        />
                                    ) : (
                                        <div style={{display: "flex", alignItems: "center", justifyContent: "center", height: "100%"}}>
                                            <div>Loading chart...</div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div style={{flex: "1", backgroundColor: "white", 
                                        borderRadius: "12px", padding: "20px", position: "relative", minWidth: "0", display: "flex", flexDirection: "column", 
                                        boxShadow: "0 8px 32px rgba(0,0,0,0.08)", overflow: "hidden", border: "1px solid #dee2e6"}}>
                                <div style={{position: "absolute", top: "0", right: "0", width: "100px", height: "100px", 
                                            background: "linear-gradient(135deg, rgba(0,129,199,0.05) 0%, rgba(44,123,229,0.05) 100%)", borderRadius: "50%", transform: "translate(30px, -30px)"}}></div>
                                <div style={{position: "absolute", bottom: "0", left: "0", width: "80px", height: "80px", 
                                            background: "linear-gradient(135deg, rgba(0,129,199,0.03) 0%, rgba(44,123,229,0.03) 100%)", borderRadius: "50%", transform: "translate(-20px, 20px)"}}></div>
                                
                                <h6 style={{margin: "0 0 20px 0", textAlign: "center", color: "#495057", fontSize: "1rem", fontWeight: "600", 
                                           position: "relative", zIndex: "1"}}>Performance Metrics</h6>
                                
                                <div style={{flex: "1", minHeight: "0", display: "flex", alignItems: "center", justifyContent: "space-between", 
                                           padding: "0 10px", position: "relative", zIndex: "1"}}>
                                    {/* Total Events Card */}
                                    <div style={{background: "linear-gradient(135deg, rgba(0,129,199,0.08) 0%, rgba(44,123,229,0.08) 100%)", 
                                               borderRadius: "16px", padding: "16px", textAlign: "center", flex: "1", margin: "0 8px", 
                                               border: "1px solid rgba(0,129,199,0.15)", boxShadow: "0 4px 16px rgba(0,129,199,0.1)"}}>
                                        <div style={{fontSize: "0.8rem", color: "#6c757d", marginBottom: "8px", fontWeight: "500", 
                                                   letterSpacing: "0.5px", textTransform: "uppercase"}}>Total Events</div>
                                        <div style={{fontSize: "1.8rem", fontWeight: "700", color: "#495057", marginBottom: "8px"}}>{campusTotal.toLocaleString()}</div>
                                        {campusTotal !== "N/A" && compareTotal && campusId !== 0 ? (
                                            <div style={{
                                                fontSize: "0.75rem", 
                                                fontWeight: "600",
                                                color: campusTotal > compareTotal ? "#dc3545" : campusTotal < compareTotal ? "#198754" : "#6c757d",
                                                backgroundColor: campusTotal > compareTotal ? "rgba(220,53,69,0.1)" : campusTotal < compareTotal ? "rgba(25,135,84,0.1)" : "rgba(108,117,125,0.1)",
                                                padding: "4px 8px",
                                                borderRadius: "20px",
                                                border: campusTotal > compareTotal ? "1px solid rgba(220,53,69,0.2)" : campusTotal < compareTotal ? "1px solid rgba(25,135,84,0.2)" : "1px solid rgba(108,117,125,0.2)",
                                                textAlign: "center"
                                            }}>
                                                <div>{campusTotal > compareTotal ? "↗" : campusTotal < compareTotal ? "↘" : "→"} {Math.abs(Math.round(campusTotal - compareTotal)).toLocaleString()} ({Math.abs(Math.round(((campusTotal - compareTotal) / compareTotal) * 100)).toLocaleString()}%)</div>
                                                <div style={{fontSize: "0.65rem", color: "#6c757d", marginTop: "2px"}}>vs corp avg {compareTotal.toLocaleString()}</div>
                                            </div>
                                        ) : campusId === 0 ? (
                                            <div style={{
                                                fontSize: "0.75rem", 
                                                fontWeight: "600",
                                                color: "#6c757d",
                                                backgroundColor: "rgba(108,117,125,0.1)",
                                                padding: "4px 8px",
                                                borderRadius: "20px",
                                                border: "1px solid rgba(108,117,125,0.2)"
                                            }}>
                                                N/A
                                            </div>
                                        ) : null}
                                    </div>
                                    
                                    {/* Avg Daily Events Card */}
                                    <div style={{background: "linear-gradient(135deg, rgba(0,129,199,0.08) 0%, rgba(44,123,229,0.08) 100%)", 
                                               borderRadius: "16px", padding: "16px", textAlign: "center", flex: "1", margin: "0 8px", 
                                               border: "1px solid rgba(0,129,199,0.15)", boxShadow: "0 4px 16px rgba(0,129,199,0.1)"}}>
                                        <div style={{fontSize: "0.8rem", color: "#6c757d", marginBottom: "8px", fontWeight: "500", 
                                                   letterSpacing: "0.5px", textTransform: "uppercase"}}>Daily Average</div>
                                        <div style={{fontSize: "1.8rem", fontWeight: "700", color: "#495057", marginBottom: "8px"}}>{campusAvgD.toLocaleString()}</div>
                                        {campusAvgD !== "N/A" && compareAvgD && campusId !== 0 ? (
                                            <div style={{
                                                fontSize: "0.75rem", 
                                                fontWeight: "600",
                                                color: campusAvgD > compareAvgD ? "#dc3545" : campusAvgD < compareAvgD ? "#198754" : "#6c757d",
                                                backgroundColor: campusAvgD > compareAvgD ? "rgba(220,53,69,0.1)" : campusAvgD < compareAvgD ? "rgba(25,135,84,0.1)" : "rgba(108,117,125,0.1)",
                                                padding: "4px 8px",
                                                borderRadius: "20px",
                                                border: campusAvgD > compareAvgD ? "1px solid rgba(220,53,69,0.2)" : campusAvgD < compareAvgD ? "1px solid rgba(25,135,84,0.2)" : "1px solid rgba(108,117,125,0.2)",
                                                textAlign: "center"
                                            }}>
                                                <div>{campusAvgD > compareAvgD ? "↗" : campusAvgD < compareAvgD ? "↘" : "→"} {Math.abs(Math.round((campusAvgD - compareAvgD) * 100) / 100).toFixed(1).toLocaleString()} ({Math.abs(Math.round(((campusAvgD - compareAvgD) / compareAvgD) * 100)).toLocaleString()}%)</div>
                                                <div style={{fontSize: "0.65rem", color: "#6c757d", marginTop: "2px"}}>vs corp avg {compareAvgD.toLocaleString()}</div>
                                            </div>
                                        ) : campusId === 0 ? (
                                            <div style={{
                                                fontSize: "0.75rem", 
                                                fontWeight: "600",
                                                color: "#6c757d",
                                                backgroundColor: "rgba(108,117,125,0.1)",
                                                padding: "4px 8px",
                                                borderRadius: "20px",
                                                border: "1px solid rgba(108,117,125,0.2)"
                                            }}>
                                                N/A
                                            </div>
                                        ) : null}
                                    </div>
                                    
                                    {/* Avg Response Time Card */}
                                    <div style={{background: "linear-gradient(135deg, rgba(0,129,199,0.08) 0%, rgba(44,123,229,0.08) 100%)", 
                                               borderRadius: "16px", padding: "16px", textAlign: "center", flex: "1", margin: "0 8px", 
                                               border: "1px solid rgba(0,129,199,0.15)", boxShadow: "0 4px 16px rgba(0,129,199,0.1)"}}>
                                        <div style={{fontSize: "0.8rem", color: "#6c757d", marginBottom: "8px", fontWeight: "500", 
                                                   letterSpacing: "0.5px", textTransform: "uppercase"}}>Response Time</div>
                                        <div style={{fontSize: "1.8rem", fontWeight: "700", color: "#495057", marginBottom: "8px"}}>{campusAvgR.toLocaleString()}</div>
                                        {campusAvgR !== "N/A" && compareAvgR && campusId !== 0 ? (
                                            <div style={{
                                                fontSize: "0.75rem", 
                                                fontWeight: "600",
                                                color: campusAvgR > compareAvgR ? "#dc3545" : campusAvgR < compareAvgR ? "#198754" : "#6c757d",
                                                backgroundColor: campusAvgR > compareAvgR ? "rgba(220,53,69,0.1)" : campusAvgR < compareAvgR ? "rgba(25,135,84,0.1)" : "rgba(108,117,125,0.1)",
                                                padding: "4px 8px",
                                                borderRadius: "20px",
                                                border: campusAvgR > compareAvgR ? "1px solid rgba(220,53,69,0.2)" : campusAvgR < compareAvgR ? "1px solid rgba(25,135,84,0.2)" : "1px solid rgba(108,117,125,0.2)",
                                                textAlign: "center"
                                            }}>
                                                <div>{campusAvgR > compareAvgR ? "↗" : campusAvgR < compareAvgR ? "↘" : "→"} {Math.abs(Math.round((campusAvgR - compareAvgR) * 100) / 100).toFixed(1).toLocaleString()} ({Math.abs(Math.round(((campusAvgR - compareAvgR) / compareAvgR) * 100)).toLocaleString()}%)</div>
                                                <div style={{fontSize: "0.65rem", color: "#6c757d", marginTop: "2px"}}>vs corp avg {compareAvgR.toLocaleString()}</div>
                                            </div>
                                        ) : campusId === 0 ? (
                                            <div style={{
                                                fontSize: "0.75rem", 
                                                fontWeight: "600",
                                                color: "#6c757d",
                                                backgroundColor: "rgba(108,117,125,0.1)",
                                                padding: "4px 8px",
                                                borderRadius: "20px",
                                                border: "1px solid rgba(108,117,125,0.2)"
                                            }}>
                                                N/A
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                                
                                <div style={{marginTop: "16px", padding: "12px", background: "rgba(0,129,199,0.05)", borderRadius: "8px", 
                                           fontSize: "0.75rem", color: "#6c757d", textAlign: "center", position: "relative", zIndex: "1"}}>
                                    {campusTotal !== "N/A" ? "📊 Compared to Corporate Average • 🟢 Better than average • 🔴 Worse than average" : "📍 Select a campus to view comparison"}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={tabItem === "second" ? "d-block" : "d-none"}
                         style={isBannerPresent() ? {height: "calc(100vh - 330px)", overflow: "hidden"} : {height: "calc(100vh - 295px)", overflow: "hidden"}}>
                        <div style={{height: "50%", overflow: "auto", borderBottom: "2px solid #dee2e6"}}>
                            <table className={"table table-sm table-white table-hover"} id={"review-table"}>
                                <thead style={{position: "sticky", top: "0", zIndex: "1001",
                                                backgroundColor: "white"}}>
                                    {trendsTableHeaders}
                                </thead>
                                <tbody id={"tBody"}>
                                    {trendsRows}
                                </tbody>
                            </table>
                        </div>
                        <div id={"review-chart"} style={{height: "50%", backgroundColor: "#f8f9fa",
                            border: "1px solid #dee2e6", display: "flex", gap: "8px", padding: "8px"}}>
                            <div style={{flex: "1", backgroundColor: "white",
                                        borderRadius: "12px", padding: "20px", position: "relative", minWidth: "0", display: "flex", flexDirection: "column",
                                        boxShadow: "0 8px 32px rgba(0,0,0,0.08)", overflow: "hidden", border: "1px solid #dee2e6"}}>
                                <h6 style={{margin: "0 0 20px 0", textAlign: "center", color: "#495057", fontSize: ".9rem", fontWeight: "600",
                                           position: "relative", zIndex: "1"}}>{kpiLabel} <strong>{campusName}</strong> Last 12 Weeks</h6>
                                <div style={{flex: "1", minHeight: "0", position: "relative", zIndex: "1"}}>
                                    {pageLoaded ? (
                                        <LineTrendingChart
                                            x_axis={true}
                                            x_axis_title={"Weeks (Sun - Sat)"}
                                            line_axis={true}
                                            line_axis_title={kpiLabel}
                                            lines={1}
                                            line_color={["#0081C7"]}
                                            line_labels={trendLineLabels}
                                            line_data={trendLineData}
                                            forceAspect={false}
                                            labels={trendAxisLabels} />
                                    ) : (
                                        <div style={{display: "flex", alignItems: "center", justifyContent: "center", height: "100%"}}>
                                            <div>Loading chart...</div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"modal fade"} id={"filtermodal2"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                     tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                    <div className={"modal-dialog"}>
                        <div className={"modal-content"}>
                            <div className={"modal-header bg-pal"}>
                                <h2 className={"modal-title"} id={"staticBackdropLabel"}>Filter Settings</h2>
                                <Button text={"Clear All"} class={"btn ms-3 pb-0 hover-text-white"}
                                        onClick={() => clearFilters()}/>
                                <button type={"button"} className={"btn-close"} id={"filterClose2"}
                                        data-bs-dismiss={"modal"} aria-label={"Close"}/>
                            </div>
                            <form id={"filterForm2"}>
                                <div className={"modal-body"}>
                                    <div className={"row align-items-center"}
                                         style={{borderBottom: "dotted 1px #b7b7b7"}}>
                                    </div>
                                    <div className={"mt-2"}>
                                        <div>
                                            <ul className={"nav nav-tabs nav-overflow header-tabs"}>
                                                <li className={"nav-item"}>
                                                    <Button text={"Area Types"}
                                                            class={filterTabItem === "areaType" ? "nav-link active" : "nav-link"}
                                                            onClick={() => setFilterTabItem("areaType")}/>
                                                </li>
                                                <li className={"nav-item"}>
                                                    <Button text={"Device Categories"}
                                                            class={filterTabItem === "deviceCat" ? "nav-link active" : "nav-link"}
                                                            onClick={() => setFilterTabItem("deviceCat")}/>
                                                </li>
                                                <li className={"nav-item"}>
                                                    <Button text={"Response Time"}
                                                            class={filterTabItem === "response" ? "nav-link active" : "nav-link"}
                                                            onClick={() => setFilterTabItem("response")}/>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className={filterTabItem === "areaType" ? "d-block" : "d-none"}>
                                            <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                                <input type={"search"} id={"areaTypeSearch"}
                                                       className={"form-control search-input"}
                                                       onKeyUp={(e) => setAreaTypeSearch(e.target.value)}/>
                                                <Button text={""} type={"button"}
                                                        class={"btn btn-primary smooth-radius-left"}
                                                        style={{height: "42px"}} icon={true}
                                                        iconClass={"fe fe-search"}/>
                                            </div>
                                            <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                                <table className={"table table-sm table-white table-hover"}>
                                                    <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                    {areaTypeTableHeaders}
                                                    </thead>
                                                    <tbody>
                                                    {areaTypeTableRows}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div className={filterTabItem === "deviceCat" ? "d-block" : "d-none"}>
                                            <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                                <input type={"search"} id={"devCatSearch"}
                                                       className={"form-control search-input"}
                                                       onKeyUp={(e) => setDevCatSearch(e.target.value)}/>
                                                <Button text={""} type={"button"}
                                                        class={"btn btn-primary smooth-radius-left"}
                                                        style={{height: "42px"}} icon={true}
                                                        iconClass={"fe fe-search"}/>
                                            </div>
                                            <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                                <table className={"table table-sm table-white table-hover"}>
                                                    <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                    {deviceCatTableHeaders}
                                                    </thead>
                                                    <tbody>
                                                    {devCatTableRows}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div className={filterTabItem === "response" ? "d-block" : "d-none"}>
                                            <form className={"was-validated"} id={"response-form"}>
                                                <div className={"form-check form-switch mt-5 mb-3"}>
                                                    <input className={"form-check-input"} id={"response-on"}
                                                           type={"checkbox"}
                                                           onChange={(e) => {
                                                               document.getElementById("response-operator").required = e.target.checked;
                                                               document.getElementById("response-value").required = e.target.checked;
                                                               formCheck("response-form", "");
                                                           }}/>
                                                    <label htmlFor={"response-on"}>Filter by response time</label>
                                                </div>
                                                <div className={"form-floating mb-3 d-inline-block me-3 align-top"}
                                                     style={{width: "33%"}}>
                                                    <select className={"form-select"} id={"response-operator"}>
                                                        <option value={"lt"}>Less than</option>
                                                        <option value={"gt"}>Greater than</option>
                                                        <option value={"eq"}>Equal to</option>
                                                    </select>
                                                    <label htmlFor={"response-operator"}>Condition</label>
                                                </div>
                                                <div className={"form-floating mb-3 d-inline-block align-top"}
                                                     style={{width: "33%"}}>
                                                    <input type={"number"} className={"form-control"}
                                                           step={1} min={0} max={3600} id={"response-value"}/>
                                                    <label htmlFor={"response-value"}>Response Time (Min)</label>
                                                    <div className={"invalid-feedback"}>
                                                        Number of minutes required!
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                                <div className={"modal-footer"}>
                                    <div>
                                        <button type={"button"} className={"btn btn-secondary"} id={"cancelFilterBtn2"}
                                                data-bs-dismiss={"modal"}>Cancel
                                        </button>
                                        <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true}
                                                spinner={true} text={"Loading"} id={"loadFilterSubmit2"}/>
                                        <button type={"button"} className={"btn btn-primary ms-3"} id={"filterSubmit2"}
                                                onClick={() => filterSubmit2()}>Submit
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <Suspense fallback={"Loading..."}>
                    <ToastContainer position={"bottom-right"} theme={"colored"} newestOnTop={true} pauseOnHover={true}
                                    autoClose={10000} closeOnClick={true}/>
                </Suspense>
            </div>
        </>
    );
};

export default CorpDashV2;